import { withSnackbar } from 'notistack';
import React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { SetAppMode } from "../../../Actions/commonAction";

class DefaultMode extends React.Component {
    componentWillMount() {
        window.sessionStorage.setItem("appMode", "config");
        this.props.SetAppMode('config');
        this.props.history.push('/config/dashboard');
    }

    render = () => null
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ SetAppMode }, dispatch);

  export default withRouter(connect(
    null,
    mapDispatchToProps,
  )(withSnackbar(DefaultMode)));
